'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

require('./chip.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Chip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClose = _ref.onClose,
      selected = _ref.selected,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'onClose', 'selected']);

  var classes = (0, _classnames2.default)('chip', selected && 'chip--selected', className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    _react2.default.createElement(_icon2.default, { className: 'chip_item chip_item--icon', name: 'cross', size: '8', onClick: onClose }),
    _react2.default.createElement(
      _text2.default,
      { className: 'chip_item chip_item--text', truncate: true },
      children
    )
  );
}

Chip.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  editable: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  selected: _propTypes2.default.bool
};

Chip.defaultProps = {};

exports.default = Chip;